import GLightbox from "glightbox";
import Splide from "@splidejs/splide";
import "whatwg-fetch";
import TailorMadeMap from "./components/tailor-made-map";
import DestinationsMap from "./components/destinations-map";
import TawkTo from "./components/tawk.to";
import FormInteractions from "./components/form-interactions";
import AddressFinder from "./components/address-finder";


if (document.readyState == "complete" && document.querySelectorAll(".tailor-made__gallery-col").length) {
	var gallerySplide = new window.Splide(".tailor-made__gallery-col");
}
function updateHolidays() {
	var destination = document.querySelector(".form__select--destination");
	var destinationValue = destination.value;

	var selectContainer = document.querySelector(".form__select--holiday");
	selectContainer.classList.add("form__select--hidden");
	var newXHR = new XMLHttpRequest();
	newXHR.open("GET", "/ajax/holidays/" + destinationValue);
	newXHR.setRequestHeader("X-Requested-With", "XMLHttpRequest");
	newXHR.onreadystatechange = function () {
		if (newXHR.readyState === 4) {
			if (newXHR.status === 200) {
				selectContainer.innerHTML = newXHR.responseText;
				selectContainer.classList.remove("form__select--hidden");
			} else {
				selectContainer.innerHTML =
					"An error occurred during your request: " +
					newXHR.status +
					" " +
					newXHR.statusText;
			}
		}
	};
	newXHR.send();
}

function updateReviews() {

	var reviewsContainer = document.querySelector(".holiday-reviews__list");
	reviewsContainer.classList.add("holiday-reviews__list--hidden");
	var newXHR = new XMLHttpRequest();
	if(this.getAttribute('data-url')){
		newXHR.open("GET", this.getAttribute('data-url') );
	}else{
		var holiday = document.querySelector(".form__select--holiday");
		var holidayValue = holiday.value;
		newXHR.open("GET", "/ajax/reviews/" + holidayValue);
	}
	newXHR.setRequestHeader("X-Requested-With", "XMLHttpRequest");
	newXHR.onreadystatechange = function () {
		if (newXHR.readyState === 4) {
			if (newXHR.status === 200) {
				reviewsContainer.innerHTML = newXHR.responseText;
				reviewsContainer.classList.remove("holiday-reviews__list--hidden");
			} else {
				reviewsContainer.innerHTML =
					"An error occurred during your request: " +
					newXHR.status +
					" " +
					newXHR.statusText;
			}
			document.querySelectorAll(
				".pagination__item .pagination__link[data-url]"
			).forEach((pagination)=>pagination.addEventListener('click',updateReviews));
		}
	};
	newXHR.send();
}

function updateHolidaySearch(item, url) {
	var selectInput = document.querySelector(
		'.holiday-search__select[name="' + item + '"]'
	);
	var selectParent = selectInput.parentNode;

	var newXHR = new XMLHttpRequest();
	newXHR.open("GET", url);
	newXHR.setRequestHeader("X-Requested-With", "XMLHttpRequest");
	newXHR.onreadystatechange = function () {
		if (newXHR.readyState === 4) {
			if (newXHR.status === 200) {
				selectParent.innerHTML = newXHR.responseText;
			} else {
				selectParent.innerHTML =
					"An error occurred during your request: " +
					newXHR.status +
					" " +
					newXHR.statusText;
			}
		}
	};
	//	newXHR.send();
}

var links = document.querySelectorAll('a[href^="#"]');

for (var link of links) {
	link.addEventListener("click", clickHandler);
}

function clickHandler(e) {
	e.preventDefault();
	if (this.classList.contains("tailor-made__trigger")) {
		return;
	}
	var href = this.getAttribute("href");
	var offsetTop = document.querySelector(href).offsetTop;

	if (this.classList.contains("tabs__link")) {
		var offsetTop = offsetTop - 75;
	}

	scroll({
		top: offsetTop,
		behavior: "smooth"
	});
}

document.onreadystatechange = function () {
	switch (document.readyState) {
		case "loading":
			// The document is still loading.

			break;
		case "interactive":
			// The document has finished loading. We can now access the DOM elements.
			// But sub-resources such as images, stylesheets and frames are still loading.
			// Equivalent of document.ready

			break;
		case "complete":
			// The page is fully loaded.
			// Equivalent of window.load

			// Inline all svg img tags
			$app.inlineSvg(".isvg");

			if (document.querySelectorAll(".nav__link--toggle").length) {
				document.querySelectorAll(".nav__link--toggle").forEach(function (item) {
					item.addEventListener("click", function (e) {
						var navToggle = item.dataset.toggle;
						var navMenu = document.querySelector(
							'.nav--toggle[data-toggle="' + navToggle + '"]'
						);
						if (navMenu.style.maxHeight) {
							navMenu.style.maxHeight = null;
						} else {
							document.querySelectorAll(".nav--toggle").forEach(function (item) {
								item.style.maxHeight = null;
							});
							navMenu.style.maxHeight = navMenu.scrollHeight + "px";
						}
					});
				});
			}

			if (document.querySelectorAll(".footer__heading--toggle").length) {
				document
					.querySelectorAll(".footer__heading--toggle")
					.forEach(function (item) {
						item.addEventListener("click", function (e) {
							if ($app.wW() < $app.breakpoints().medium) {
								//e.preventDefault();
								var buttonParent = item.parentNode;
								var linkInfo = buttonParent.querySelector(".list--toggle");
								if (linkInfo.style.maxHeight) {
									item.classList.remove("footer__heading--up");
									item.classList.add("footer__heading--down");
									linkInfo.style.maxHeight = null;
								} else {
									item.classList.add("footer__heading--up");
									item.classList.remove("footer__heading--down");
									linkInfo.style.maxHeight = linkInfo.scrollHeight + "px";
								}
							}
						});
					});
			}

			if (document.readyState == "complete" && document.querySelectorAll(".hero.splide").length) {
				var heroSplide = new window.Splide(".hero", {
					type: "fade",
					gap: 0,
					autoplay: true,
					interval: 6000,
					arrows: false,
					pagination: false,
					perMove: 1,
					pagePage: 1,
					rewind: true
				});
				heroSplide.mount();
			}

			if (document.readyState == "complete" && document.querySelectorAll(".tailor-made__gallery-col").length) {
				gallerySplide.mount();
			}

			if (document.readyState == "complete" && document.querySelectorAll(".inspiration__slider").length) {
				var inspirationSplide = new window.Splide(".inspiration__slider", {
					type: "fade",
					gap: 0,
					autoplay: true,
					interval: 4000,
					arrows: false,
					pagination: true,
					perMove: 1,
					pagePage: 1,
					rewind: true
				});
				inspirationSplide.mount();
			}

			if (document.querySelectorAll(".holiday-introduction__slide").length) {
				document
					.querySelector(".holiday-introduction__slide")
					.classList.add("holiday-introduction__slide--active");

				document
					.querySelectorAll(".holiday-introduction__next")
					.forEach(function (el, i) {
						el.addEventListener("click", function (e) {
							var parentNode = this.closest(".holiday-introduction__slide");
							parentNode.classList.remove(
								"holiday-introduction__slide--active"
							);

							if (parentNode.nextElementSibling) {
								parentNode.nextElementSibling.classList.add(
									"holiday-introduction__slide--active"
								);
							} else {
								document
									.querySelector(".holiday-introduction__slide")
									.classList.add("holiday-introduction__slide--active");
							}
						});
					});
			}

			if (document.querySelectorAll(".tailor-made__splide").length) {
				const tailorMadeSplides = document.getElementsByClassName(
					"tailor-made__splide"
				);
				Object.keys(tailorMadeSplides).forEach(key => {
					var destroySplideDesktop =
						tailorMadeSplides[key].querySelectorAll(".splide__slide").length > 3
							? false
							: true;
					var destroySplideMobile =
						tailorMadeSplides[key].querySelectorAll(".splide__slide").length > 1
							? false
							: true;

					new Splide(tailorMadeSplides[key], {
						padding: "1px",
						destroy: destroySplideDesktop,
						type: "loop",
						interval: 5000,
						gap: 30,
						arrows: true,
						pagination: false,
						perPage: 3,
						breakpoints: {
							639: {
								destroy: destroySplideMobile,
								perPage: 1
							}
						}
					}).mount();
				});

				document
					.querySelectorAll(".tailor-made__splide")
					.forEach(function (item) {
						var children = item.getElementsByClassName(
							"tailor-made__title--box"
						);
						$app.equalHeights(children);
					});
			}

			if (document.querySelectorAll(".js-holiday-search__toggle").length) {
				document
					.querySelectorAll(".js-holiday-search__toggle")
					.forEach(function (item) {
						item.addEventListener("click", function (e) {
							document
								.querySelector(".js-holiday-search__buttons")
								.classList.toggle("holiday-search__buttons--hidden");
							document
								.querySelector(".js-holiday-search__fields")
								.classList.toggle("holiday-search__fields--hidden");
						});
					});
			}
			if (document.querySelectorAll(".destinations__map").length) {
				document
					.querySelectorAll(".destinations__map a")
					.forEach(function (item) {
						item.addEventListener("click", function (e) {
							e.preventDefault();

							if (item.classList.contains("destinations__map--active")) {
								document
									.querySelector(".destinations-listings__listing--visible")
									.classList.remove("destinations-listings__listing--visible");
								document
									.querySelector(".destinations__map--active")
									.classList.remove("destinations__map--active");
							} else {
								if (
									document.querySelector(
										".destinations-listings__listing--visible"
									) !== null
								) {
									document
										.querySelector(".destinations-listings__listing--visible")
										.classList.remove(
											"destinations-listings__listing--visible"
										);
								}
								if (
									document.querySelector(".destinations__map--active") !== null
								) {
									document
										.querySelector(".destinations__map--active")
										.classList.remove("destinations__map--active");
								}

								item.classList.toggle("destinations__map--active");

								var scrolled = window.pageYOffset;

								var parentEl = document.querySelector(".destinations");
								var parentTop = parentEl.offsetTop;

								console.log(item)

								var itemId = item.getAttribute("xlink:href");

								var itemEl = document.querySelector(itemId);
								itemEl.classList.toggle(
									"destinations-listings__listing--visible"
								);
								var popupWidth = itemEl.offsetWidth;

								itemEl.style.top = e.clientY + scrolled - parentTop - 40 + "px";
								itemEl.style.left = e.clientX - popupWidth - 40 + "px";
							}
						});
					});
			}

			if (document.querySelectorAll(".form__col--rating").length) {
				var checkPrev = function (item) {
					var prev = item.previousElementSibling;

					if (prev) {
						prev.classList.add("star");
						checkPrev(prev);
					}
				};
				document
					.querySelectorAll(".form__col--rating")
					.forEach(function (column) {
						var ratingLabel = column.querySelector(".form__rating-text");

						column
							.querySelectorAll(".form__rating label")
							.forEach(function (item) {
								item.addEventListener("click", function (e) {
									e.preventDefault();
									var itemRadio = item.children[0];

									column
										.querySelectorAll(".form__rating label")
										.forEach(function (item) {
											item.classList.remove("star");
										});

									if (itemRadio.checked) {
										itemRadio.checked = false;
										ratingLabel.innerHTML = "Please Select";
									} else {
										itemRadio.checked = true;
										var itemRadioValue = itemRadio.value;

										switch (itemRadioValue) {
											case "1":
												ratingLabel.innerHTML = "Unsatisfactory";
												break;
											case "2":
												ratingLabel.innerHTML = "Fair";
												break;
											case "3":
												ratingLabel.innerHTML = "Average";
												break;
											case "4":
												ratingLabel.innerHTML = "Good";
												break;
											case "5":
												ratingLabel.innerHTML = "Excellent";
												break;
											default:
												ratingLabel.innerHTML = "Please Select";
										}

										item.classList.add("star");
										checkPrev(item);
									}
								});
							});
					});
			}

			if (document.querySelectorAll(".filter__buttons").length) {
				document.querySelectorAll(".filter__button").forEach(function (item) {
					item.addEventListener("click", function (e) {
						var listingItemSelector = item.dataset.listings;
						var listingItemBlock = listingItemSelector.split("--")[0];
						var listingItem = document.querySelector("." + listingItemSelector);

						document
							.querySelectorAll(".filter__button")
							.forEach(function (item) {
								item.classList.add("button--secondary");
								item.classList.remove("button--active");
							});

						document
							.querySelectorAll("." + listingItemBlock)
							.forEach(function (item) {
								item.classList.add(listingItemBlock + "--hidden");
							});

						item.classList.remove("button--secondary");
						item.classList.add("button--active");
						listingItem.classList.remove(listingItemBlock + "--hidden");
						if (listingItem.classList.contains("map")) {
							map.setCenter(latlngbounds.getCenter());
							map.fitBounds(latlngbounds);
						}
					});
				});
			}

			if (document.querySelectorAll(".holiday-listings--full").length) {
				var holidayListingsSimple = document.querySelector(
					".holiday-listings--simple"
				);
				document
					.querySelectorAll(".holiday-listings--full .listing")
					.forEach(function (item) {
						var placeholderElement = document.createElement("div");
						var holidayTitle = item
							.querySelector(".listing__title")
							.innerHTML.split("<")[0]
							.trim();
						var holidayLink = item
							.querySelector(".button")
							.getAttribute("href");
						var holidayContent = `<div class="listing listing--flex"><h3 class="listing__title listing__title--flex">${holidayTitle}</h3><a href="${holidayLink}" class="button button--icon button--right">More details</a></div>`;
						placeholderElement.innerHTML = holidayContent;
						var holidayObject = placeholderElement.firstChild;
						holidayListingsSimple.append(holidayObject);
					});
			}

			if (document.querySelectorAll(".button--toggle").length) {
				document.querySelectorAll(".button--toggle").forEach(function (item) {
					item.addEventListener("click", function (e) {
						if (item.dataset.toggle) {
							var buttonToggle = item.dataset.toggle;
							var buttonMenu = document.querySelector(
								'.holiday-itinerary__download-list[data-toggle="' +
								buttonToggle +
								'"]'
							);
							buttonMenu.classList.toggle(
								"holiday-itinerary__download-list--hidden"
							);
						} else {
							var buttonParent = item.parentNode.parentNode;
							var toggleEl = buttonParent.querySelector(
								".holiday-extensions__toggle"
							);
							if (toggleEl === null) {
								var toggleEl = buttonParent.querySelector(
									".border-box__toggle-area"
								);
							}
							if (toggleEl.style.maxHeight) {
								item.classList.remove("button--up");
								item.classList.add("button--down");
								item.innerHTML = "More Details";
								toggleEl.style.maxHeight = null;
							} else {
								item.classList.add("button--up");
								item.classList.remove("button--down");
								item.innerHTML = "Hide Details";
								toggleEl.style.maxHeight = toggleEl.scrollHeight + "px";
							}
						}
					});
				});
			}

			if (document.querySelectorAll(".border-box__toggle").length) {
				document
					.querySelectorAll(".border-box__toggle")
					.forEach(function (item) {
						item.addEventListener("click", function (e) {
							var buttonParent = item.parentNode;
							var linkInfo = buttonParent.querySelector(
								".border-box__toggle-area"
							);
							if (linkInfo.style.maxHeight) {
								item.classList.remove("border-box__toggle--up");
								item.classList.add("border-box__toggle--down");
								linkInfo.style.maxHeight = null;
							} else {
								item.classList.add("border-box__toggle--up");
								item.classList.remove("border-box__toggle--down");
								linkInfo.style.maxHeight = linkInfo.scrollHeight + "px";
							}
						});
					});
			}

			if (document.querySelectorAll(".holiday-search__toggle").length) {
				document
					.querySelectorAll(".holiday-search__toggle")
					.forEach(function (item) {
						item.addEventListener("click", function (e) {
							var buttonToggle = item.dataset.toggle;
							var searchBar = document.querySelector(
								'.holiday-search[data-toggle="' + buttonToggle + '"]'
							);
							if (searchBar.style.maxHeight) {
								item.classList.remove("button--up");
								item.classList.add("button--down");
								searchBar.style.maxHeight = null;
							} else {
								item.classList.add("button--up");
								item.classList.remove("button--down");
								searchBar.style.maxHeight = searchBar.scrollHeight + "px";
							}
						});
					});
			}

			if (document.querySelectorAll(".form__select--destination").length) {
				document.querySelector(
					".form__select--destination"
				).oninput = updateHolidays;
			}

			if (document.querySelectorAll(".form__select--holiday").length) {
				document.querySelector(
					".form__select--holiday"
				).oninput = updateReviews;
			}

			if (document.querySelectorAll(".pagination__item .pagination__link[data-url]").length) {
				document.querySelectorAll(
					".pagination__item .pagination__link[data-url]"
				).forEach((pagination)=>pagination.addEventListener('click',updateReviews));
			}

			if (
				document.querySelectorAll(".holiday-search__select--dynamic").length
			) {
				function generateUrl(obj) {
					var l = Object.keys(obj).length;

					Object.keys(obj).forEach(function (item) {
						var newUrl = "ajax/search/" + item + "?";
						var i = 0;
						var searchSelector = item;

						Object.keys(obj).forEach(function (item) {
							if (i === l - 1) {
								newUrl = newUrl + item + "=" + obj[item];
								updateHolidaySearch(searchSelector, newUrl);
							} else {
								newUrl = newUrl + item + "=" + obj[item] + "&";
							}
							i++;
						});
					});
				}

				var l = document.querySelectorAll(".holiday-search__select--dynamic")
					.length;
				var newUrlObj = {};

				document
					.querySelectorAll(".holiday-search__select--dynamic")
					.forEach(function (item) {
						var itemName = item.getAttribute("name");
						newUrlObj[itemName] = "";

						item.addEventListener("input", function (event) {
							var i = 0;
							document
								.querySelectorAll(".holiday-search__select--dynamic")
								.forEach(function (item) {
									var itemName = item.getAttribute("name");
									var itemValue = item.value;
									newUrlObj[itemName] = itemValue;
									if (i === l - 1) {
										generateUrl(newUrlObj);
									}
									i++;
								});
						});
					});
			}

			if (document.querySelectorAll(".tabs--sticky").length) {
				var sectionsObj = {};

				function getPosition(obj) {
					var i = 0;
					var l = Object.keys(obj).length;

					Object.keys(obj).forEach(function (item) {
						sectionsObj[item] = document.querySelector(item).offsetTop;
						i++;
					});
				}

				var i = 0;
				var tabsL = document.querySelectorAll(".tabs--sticky .tabs__link")
					.length;
				var tabsObj = {};
				document
					.querySelectorAll(".tabs--sticky .tabs__link")
					.forEach(function (item) {
						var itemId = item.getAttribute("href");
						tabsObj[itemId] = "";
						if (i === tabsL - 1) {
							getPosition(tabsObj);
						}
						i++;
					});

				var tabIndex = 0;
				window.addEventListener("scroll", function (event) {
					var y = window.scrollY;
					var yOffset = 75;
					var y = y + yOffset;

					document
						.querySelectorAll(".tabs--sticky .tabs__link")
						.forEach(function (item) {
							item.classList.remove("tabs__link--active");
						});

					if (y >= sectionsObj[Object.keys(sectionsObj)[tabIndex + 1]]) {
						tabIndex++;
					} else if (y < sectionsObj[Object.keys(sectionsObj)[tabIndex]]) {
						--tabIndex;
					}

					if (
						(y >= sectionsObj[Object.keys(sectionsObj)[tabIndex]] &&
							y < sectionsObj[Object.keys(sectionsObj)[tabIndex + 1]]) ||
						tabIndex + 1 === tabsL
					) {
						var activeTabId = Object.keys(sectionsObj)[tabIndex];
						var activeTab = document.querySelector(
							'.tabs--sticky .tabs__link[href="' + activeTabId + '"]'
						);

						activeTab.classList.add("tabs__link--active");
					} else if (tabIndex = -1) {
						var activeTabId = Object.keys(sectionsObj)[0];
						var activeTab = document.querySelector(
							'.tabs--sticky .tabs__link[href="' + activeTabId + '"]'
						);

						activeTab.classList.add("tabs__link--active");
					}
				});

				document
					.querySelector(".tabs__select")
					.addEventListener("change", function () {
						var href = this.value;
						var offsetTop = document.querySelector(href).offsetTop;

						scroll({
							top: offsetTop,
							behavior: "smooth"
						});
					});
			}

			if (document.querySelectorAll(".people__link").length) {
				document.querySelectorAll(".people__image").forEach(function (item) {
					item.addEventListener("click", function (e) {
						this.parentNode.querySelector(".people__link").click();
					});
				});
				const peopleLightbox = GLightbox({
					selector: ".people__link",
					loop: true,
					width: "400px",
					height: "auto"
				});
			}

			if (
				document.querySelectorAll(".holiday-gallery").length ||
				document.querySelectorAll(".tailor-made__gallery").length
			) {
				if (document.querySelectorAll(".holiday-gallery__button").length) {
					document
						.querySelector(".holiday-gallery__button")
						.addEventListener("click", function (e) {
							document
								.querySelector(".holiday-gallery__content--photo")
								.click();
						});
				}

				const holidayPhotoLightbox = GLightbox({
					selector: ".holiday-gallery__content--photo",
					loop: true
				});
				const holidayVideoLightbox = GLightbox({
					selector: ".holiday-gallery__content--video",
					loop: true
				});
				const tMPhotoLightbox = GLightbox({
					selector: ".tailor-made__gallery--photo",
					loop: true
				});
				const tMVideoLightbox = GLightbox({
					selector: ".tailor-made__gallery--video",
					loop: true
				});
			}

			if (document.querySelectorAll(".tailor-made__listings--full").length) {
				var holidayListingsSimple = document.querySelector(
					".tailor-made__listings--simple"
				);
				document
					.querySelectorAll(".tailor-made__listings--full .tailor-made__row")
					.forEach(function (item) {
						var placeholderElement = document.createElement("div");
						var holidayTitle = item
							.querySelector(".tailor-made__title")
							.innerHTML.trim();
						var holidayLink = item
							.querySelector(".button")
							.getAttribute("href");
						var holidayContent = `<div class="listing listing--flex"><h3 class="listing__title listing__title--flex">${holidayTitle}</h3><a href="${holidayLink}" class="button button--icon button--right button--sq">View details</a></div>`;
						placeholderElement.innerHTML = holidayContent;
						var holidayObject = placeholderElement.firstChild;
						holidayListingsSimple.append(holidayObject);
					});
			}

			if (document.querySelectorAll(".tailor-made__map").length) {
				$app.tailorMadeMap(".tailor-made__map");
			}

			if (document.querySelectorAll(".holiday-listings__map").length) {
				$app.destinationsMap(".holiday-listings__map");
			}

			/*
				handle basic 'what's this' functionality
				uses data-show and data-target attributes on source and target elements
				<a href="#" data-show="targetName">What's this</a>
				<p data-target="targetName">show this stuff</p>
			*/
			if (document.querySelectorAll("[data-show]").length) {
				document.querySelectorAll("[data-show]").forEach(el => {
					el.addEventListener("click", function (e) {
						e.preventDefault;
						const target = this.dataset.show;
						document
							.querySelectorAll(`[data-target='${target}']`)
							.forEach(el => {
								el.classList.toggle("hidden");
							});
					});
				});
			}

			/*
				handle hiding already visible items
				could probably consolidate this with the above method to make
				something more succinct
			*/
			if (document.querySelectorAll("[data-hide]").length) {
				document.querySelectorAll("[data-hide]").forEach(el => {
					el.addEventListener("click", function (e) {
						e.preventDefault;
						const target = this.dataset.hide;
						document
							.querySelectorAll(`[data-target='${target}']`)
							.forEach(el => {
								el.classList.toggle("hidden");
							});
					});
				});
			}

			if (document.querySelectorAll("form[data-handle]").length) {
				document
					.querySelectorAll("form[data-handle]")
					.forEach(function (form) {
						var formHandle = form.dataset.handle;
						console.log(formHandle);

						window
							.fetch("/ajax/freeform?form=" + formHandle, {
								credentials: "same-origin",
								method: "GET"
							})
							.then(response => response.json())
							.then(json => {
								form.querySelector("input[name=formHash]").value = json.hash;

								// Locate and update the CSRF input
								var csrf = json.csrf;
								form.querySelector("input[name=" + csrf.name + "]").value =
									csrf.value;
							})
							.catch(error => {
								throw new Error(error);
							});
					});
			}

			$app.tawkTo();

			$app.formInteractions();

			$app.addressFinder();

			$app.backToTop();

			break;
	}
};

// Resize event
window.addEventListener("resize", function (event) {
	if (document.querySelectorAll(".tailor-made__splide").length) {
		document.querySelectorAll(".tailor-made__splide").forEach(function (item) {
			var children = item.getElementsByClassName("tailor-made__title--box");
			$app.equalHeights(children);
		});
	}
});

// Utilities and behaviours namespaced to $app
// use these functions by calling $app.method();
var $app = {
	// Allows you to query the window width against the breakpoints. These MUST match breakpoints
	// set in _vars.scss

	// Example
	//
	// if ($app.wW() >= $app.breakpoints().small) {
	//  code to run when the window hits large breakpoint
	// }
	//
	breakpoints: function () {
		var obj = {
			xsmall: "460",
			small: "640",
			medium: "768",
			large: "1024",
			xlarge: "1280",
			xxlarge: "1600"
		};

		return obj;
	},

	wW: function () {
		return window.innerWidth;
	},

	// Sets element heights to the same
	// Usually worth duplicating code in window.load and window.resize
	// Will automatically reset the height correctly on resize thanks to the line
	// .css({'height': 'auto'});
	// I usually try to use it with the class .js-height

	// Usage: $app.equalHeights('.js-height');

	// If you're using the same 'module' in multiple areas this will prevent it from
	// setting the height across all of them
	// var sameHeight = document.querySelectorAll(".js-sameheight");
	// sameHeight.forEach((e) => {
	// var children = e.querySelectorAll('.js-height');
	// $app.equalHeights(children)
	// });
	// });

	// $('.js-sameheight').each(function(){
	// 	var children = $(this).find('.js-height');
	//
	// 	$app.equalHeights(children);
	// })
	equalHeights: function (elements) {
		var tallest = 0;

		for (let item of elements) {
			item.style.height = "auto";
			tallest = item.offsetHeight > tallest ? item.offsetHeight : tallest;
		}

		for (let item of elements) {
			item.style.height = tallest + "px";
		}
	},

	// function for setting cookies
	setCookie: function (name, value, days) {
		var expires = "";
		if (days) {
			var date = new Date();
			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
			expires = "; expires=" + date.toUTCString();
		}
		document.cookie = name + "=" + (value || "") + expires + "; path=/";
	},

	// function for getting cookies
	getCookie: function (name) {
		var nameEQ = name + "=";
		var ca = document.cookie.split(";");
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == " ") c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
		}
		return null;
	},

	// function to erase a cookie
	eraseCookie: function (name) {
		document.cookie = name + "=; Max-Age=-99999999;";
	},

	// function to inline an img with an svg
	// Usage: $app.inlineSvg('.isvg');
	inlineSvg: function (selector) {
		document.querySelectorAll(selector).forEach(el => {
			const imgID = el.getAttribute("id");
			const imgClass = el.getAttribute("class");
			const imgURL = el.getAttribute("src");

			fetch(imgURL)
				.then(data => data.text())
				.then(response => {
					const parser = new DOMParser();
					const xmlDoc = parser.parseFromString(response, "text/html");
					let svg = xmlDoc.querySelector("svg");

					if (typeof imgID !== "undefined") {
						svg.setAttribute("id", imgID);
					}

					if (typeof imgClass !== "undefined") {
						svg.setAttribute("class", imgClass + " replaced-svg");
					}

					svg.removeAttribute("xmlns:a");

					el.parentNode.replaceChild(svg, el);
				});
		});
	},

	tailorMadeMap: function (mapEl) {
		TailorMadeMap.init(mapEl);
	},

	destinationsMap: function (mapEl) {
		DestinationsMap.init(mapEl);
	},

	tawkTo: function () {
		TawkTo.init();
	},

	formInteractions: function () {
		const forms = document.querySelectorAll("form");
		Array.from(forms, function (form) {
			FormInteractions.init(form);
		});
	},

	addressFinder: function () {
		const forms = document.querySelectorAll("form");
		Array.from(forms, function (form) {
			AddressFinder.init(form);
		});
	},

	backToTop: function () {
		const $backToTop = document.getElementById("backToTop");

		var scrollReveal = function () {
			var y = window.scrollY;
			if (y >= 800) {
				$backToTop.className = "back-to-top is-active";
			} else {
				$backToTop.className = "back-to-top";
			}
		};

		window.addEventListener("scroll", scrollReveal);
	}
}; // end of $app
